export const ACCESS_TOKEN = 'ACCESS_TOKEN'
export const TENANT_ID = 'TENANT_ID'
export const A_ACCESS_TOKEN = 'A_ACCESS_TOKEN'
export const A_DOTNET_ACCESS_TOKEN = 'A_DOTNET_ACCESS_TOKEN'
export const A_TENANT_ID = 'A_TENANT_ID'

export const USER_TYPE = 'USER_TYPE'

export const USER_USERNAME = 'USER_USERNAME'
export const REGISTER_TENANT_ID = 'REGISTER_TENANT_ID'
export const CURRENT_TENANT_ID = 'CURRENT_TENANT_ID'
export const USER_USERID = 'USER_USERID'
